var $ = require("jquery");
import moment from "moment/moment.js";
// time to wait before a hook is called to make the NEU-badge disappear when reading an article
const ARTICLE_READ_HOOK_DELAY = 1800; // ms
const NEW_BADGE = `<div class="neubadge badge bg-primary d-flex align-items-center" data-neubadge >NEU</div>`;

function extractEventIdFromUrl(url) {
  let ar = url.split(/\/events\/|\?/); // (a) ['http://localhost:2999', '7665']
  if (ar.length == 1) { return } //       (b) ['http://localhost:2999', '7665', 'ort=123']

  const ptn = /^\d+$/;
  for (let i=0; i < ar.length; i++) {
    if (ar[i].match(ptn)) {
      return parseInt(ar[i]);
    }
  }
  return null;
}

function pushEventIdToListOfEventsRead(eventId){
  let eventIdsRead = JSON.parse(window.localStorage.getItem("event_ids_read"));
  if (!eventIdsRead) {
    eventIdsRead = [];
  }

  if (!eventIdsRead.includes(eventId)) {
    // console.log(`[${eventIdsRead}].push(${eventId});`);
    eventIdsRead.push(eventId);
    // console.log(`window.localStorage.setItem("event_ids_read", [${eventIdsRead}])`);
    window.localStorage.setItem("event_ids_read", JSON.stringify(eventIdsRead));
  }
  return true;
}

function removeEventsNeuBadges(b_with_animation){
  const eventIdsRead = JSON.parse(window.localStorage.getItem("event_ids_read"));
  if (!eventIdsRead) { return }

  for (let i=0; i<eventIdsRead.length; i++){
    const eventId = eventIdsRead[i];
    if (b_with_animation) {
      // console.log(`remove NEU-badge for Event#"${eventId}" slowly`);
      $("[data-event-id='" + eventId + "']").find(".neubadge").hide(333, function(){ $(this).remove() });
    } else {
      console.log(`remove NEU-badge for Event#"${eventId}" instantly`);
      $("[data-event-id='" + eventId + "']").find(".neubadge").remove();
    }
  }
}

function handleEventWithNeuBadge(eventId){
  if (pushEventIdToListOfEventsRead(eventId)) {
    removeEventsNeuBadges(true);
  }
}

function handleEventReading(e){
  // <perform some checks>
  if (e.originalEvent.detail.url.endsWith("/events") ||
      e.originalEvent.detail.url.endsWith("/events/")) {
    // console.log("handleEventReading we are on events/ --> return");
    return;
  }

  const eventId = extractEventIdFromUrl(e.originalEvent.detail.url);
  if (eventId == null) {
    // console.log("unable to extract eventId from URL (most probably we are not on an event-URL) -> return");
    return;
  }

  if ($("[data-event-id]").length != 1) {
    // console.log(`found |${$("[data-event-id]").length}| of $("[data-event-id]") (must be exactly one) -> return`);
    return;
  }

  if ($("[data-event-id]").find("[data-neubadge]").length != 1) {
    // console.log(`found |${$("[data-event-id]").find("[data-neubadge]").length}| of $("[data-neubadge]") (must be exactly one) -> return"` );
    return;
  }
  // </perform some checks>
  handleEventWithNeuBadge(eventId);
}

function extractArticleIdFromUrl(url) {
  let ar = url.split(/\/neues\/|\?/); // ['http://localhost:2999', '447-2022-38-0-00000000000026895510', 'ort=17']
  if (ar.length === 1) { return }

  for (let i = ar.length - 1; i >= 0; i -= 1) {
    const segment = ar[i];
    if (typeof segment === 'string' && segment.indexOf('ort') === -1 && segment.length >= 20) {
      return segment;
    }
  }
  return null;
}

function pushArticleIdToListOfArticlesRead(articleId){
  let articleIdsRead = JSON.parse(window.localStorage.getItem("article_ids_read"));
  if (!articleIdsRead) {
    articleIdsRead = [];
  }

  if (!articleIdsRead.includes(articleId)) {
    console.log(`[${articleIdsRead}].push(${articleId});`);
    articleIdsRead.push(articleId);
    console.log(`window.localStorage.setItem("article_ids_read", [${articleIdsRead}])`);
    window.localStorage.setItem("article_ids_read", JSON.stringify(articleIdsRead));
  }
  return true;
}

// remove all articles' NEU-badge if they had been read
function removeArticlesNeuBadges(b_with_animation){
  const articleIdsRead = JSON.parse(window.localStorage.getItem("article_ids_read"));
  if (!articleIdsRead) { return }

  for (let i=0; i<articleIdsRead.length; i++){
    const articleId = articleIdsRead[i];
    if (b_with_animation) {
      // console.log(`remove NEU-badge for "${articleId}" slowly`);
      $("[data-article-id='" + articleId + "']").find(".neubadge").hide(333, function(){ $(this).remove() });
    } else {
      // console.log(`remove NEU-badge for "${articleId}" instantly`);
      $("[data-article-id='" + articleId + "']").find(".neubadge").remove();
    }
  }
}

function handleArticleWithNeuBadge(articleId){
  if (pushArticleIdToListOfArticlesRead(articleId)) {
    removeArticlesNeuBadges(true);
  }
}

function handleArticleReading(e){
  // <perform some checks>
  if (e.originalEvent.detail.url.endsWith("/neues") ||
      e.originalEvent.detail.url.endsWith("/neues/")) {
    // console.log("handleReadingThisNewArticle we are on neues/ --> return");
    return;
  }

  const articleId = extractArticleIdFromUrl(e.originalEvent.detail.url);
  if (articleId == null) {
    // console.log("unable to extract articleId from URL (most probably we are not on an article-URL) -> return");
    return;
  }

  if ($("[data-article-id]").length != 1) {
    // console.log(`found |${$("[data-article-id]").length}| of $("[data-article-id]") (must be exactly one) -> return`);
    return;
  }

  if ($("[data-article-id]").find("[data-neubadge]").length != 1) {
    // console.log(`found |${$("[data-article-id]").find("[data-neubadge]").length}| of $("[data-neubadge]") (must be exactly one) -> return"` );
    return;
  }
  // </perform some checks>

  handleArticleWithNeuBadge(articleId);
}

/**
  * Convert a date in format 'yyyy-mm-dd' into the german equivalent: 'dd.mm.yyyy'
  */
function convEnDateToGer(s_date) {
  let [y, m, d] = s_date.split('-');
  return `${d}.${m}.${y}`;
}

function normaliseFilterValues(value, delimiter = ',') {
  if (Array.isArray(value)) {
    const splitValues = value
      .reduce((accumulator, entry) => accumulator.concat(entry.toString().split(delimiter)), []);
    return splitValues
      .map((entry) => entry.trim())
      .filter((entry) => entry.length > 0);
  }

  if (value === null || value === undefined) {
    return [];
  }

  return value.toString()
    .split(delimiter)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

function getNewsFiltersFromStorage() {
  try {
    return JSON.parse(window.localStorage.getItem('news_filters')) || {};
  } catch (_) {
    return {};
  }
}

const NEWS_SCROLL_THRESHOLD_PX = 300;
const NEWS_SCROLL_DEBOUNCE_MS = 150;
const NEWS_SCROLL_NAMESPACE = '.newsInfiniteScroll';
const NEWS_SCROLL_LOG_PREFIX = '[news-scroll]';
const NEWS_LIST_LOADER_ID = 'list_loader';
const NEWS_FINISHED_MESSAGE_CLASS = 'news-finished-message';
const NEWS_FILTER_HINT_CLASS = 'news-filter-active-hint';
const NEWS_FILTER_MODAL_CLOSE_MS = 260;

let newsInfiniteScrollState = null;

function logNewsScroll(level, message, payload = null) {
  const logger = typeof console[level] === 'function' ? console[level] : console.log;
  if (payload === null) {
    logger(`${NEWS_SCROLL_LOG_PREFIX} ${message}`);
  } else {
    logger(`${NEWS_SCROLL_LOG_PREFIX} ${message}`, payload);
  }
}

function debounce(callback, wait) {
  let timeoutId = null;

  const debounced = function(...args) {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => callback.apply(this, args), wait);
  };

  debounced.cancel = function() {
    window.clearTimeout(timeoutId);
    timeoutId = null;
  };

  return debounced;
}

function escapeHtml(value) {
  const safeValue = value === null || value === undefined ? '' : value;
  return String(safeValue)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function safeJsonParse(rawValue, fallbackValue) {
  if (!rawValue) return fallbackValue;

  try {
    return JSON.parse(rawValue);
  } catch (_) {
    return fallbackValue;
  }
}

function isNewsIndexPage() {
  return $('#news-loaded-list').length === 1 && /^\/neues\/?$/.test(window.location.pathname);
}

function isNewsFilterActive() {
  const $list = $('#news-loaded-list');
  if ($list.length > 0 && $list.data('filter-active') !== undefined) {
    const serverFilterActive = $list.data('filter-active') === true || $list.data('filter-active') === 'true';
    if (serverFilterActive) return true;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const urlFilterActive = ['date_from', 'date_to', 'rubric_level_two_names', 'mo_onlinecategories']
    .some((key) => {
      const value = urlParams.get(key);
      return value !== null && value !== '';
    });
  if (urlFilterActive) return true;

  return isStoredNewsFilterActive();
}

function isStoredNewsFilterActive() {
  const stored = getNewsFiltersFromStorage();
  const allRubrics = $('[data-rubric]').map(function() { return $(this).data('rubric'); }).get().sort();
  const storedRubrics = normaliseFilterValues(stored.rubric_level_two_names).sort();

  return (
    (storedRubrics.length > 0 && storedRubrics.join() !== allRubrics.join()) ||
    !!(stored.date_from || stored.date_to) ||
    normaliseFilterValues(stored.mo_onlinecategories, '|').length > 0
  );
}

function isNearNewsPageBottom() {
  const scrollBottom = $(window).scrollTop() + $(window).height();
  const documentHeight = $(document).height();
  return scrollBottom >= documentHeight - NEWS_SCROLL_THRESHOLD_PX;
}

function getCurrentOrtId() {
  const currentOrtId = safeJsonParse(window.localStorage.getItem('current_city_id'), null);
  if (currentOrtId) return currentOrtId;

  const mainCity = safeJsonParse(window.localStorage.getItem('main_city'), {});
  if (mainCity && mainCity.id) return mainCity.id;

  return getUrlParameter('ort') || '';
}

function getNewsFilterRequestValue(key) {
  const $list = $('#news-loaded-list');
  const value = $list.length > 0 ? $list.data(key) : null;
  if (value !== null && value !== undefined && value !== '') return value;

  const paramKey = key.replace(/-/g, '_');
  const urlValue = getUrlParameter(paramKey);
  if (urlValue !== '') return urlValue;

  const stored = getNewsFiltersFromStorage();
  const storageValue = stored[paramKey];
  if (Array.isArray(storageValue)) return storageValue.join(paramKey === 'mo_onlinecategories' ? '|' : ',');
  return storageValue || '';
}

function getCurrentCityName() {
  const cityName = $('.main_city_name').first().text().trim();
  if (cityName.length > 0) return cityName;

  const mainCity = safeJsonParse(window.localStorage.getItem('main_city'), {});
  return mainCity && mainCity.name ? mainCity.name : '';
}

function getNewsReadArticleIds() {
  const storedIds = safeJsonParse(window.localStorage.getItem('article_ids_read'), []);
  return new Set(Array.isArray(storedIds) ? storedIds.map((id) => String(id)) : []);
}

function getRenderedNewsArticleIds() {
  return new Set(
    $('[data-article-id]').map(function() {
      return String($(this).data('article-id'));
    }).get()
  );
}

function showNewsLoader($list) {
  if ($(`#${NEWS_LIST_LOADER_ID}`).length > 0) return;

  $list.append(
    `<div id="${NEWS_LIST_LOADER_ID}" class="row mt-3">` +
      '<div class="col-12 justify-content-center text-center">' +
        '<div class="spinner-border text-primary text-center" role="status"></div>' +
      '</div>' +
    '</div>'
  );
}

function removeNewsLoader() {
  $(`#${NEWS_LIST_LOADER_ID}`).remove();
}

function initializeNewsFilterModalAnimation() {
  const modal = document.getElementById('articles-filter-modal');
  if (!modal || modal.dataset.sheetAnimationBound === 'true') return;

  modal.dataset.sheetAnimationBound = 'true';

  modal.addEventListener('hide.bs.modal', function(event) {
    if (modal.dataset.allowSheetHide === 'true') {
      modal.dataset.allowSheetHide = 'false';
      return;
    }

    if (modal.classList.contains('sheet-closing')) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    modal.classList.add('sheet-closing');

    window.setTimeout(function() {
      modal.dataset.allowSheetHide = 'true';
      $(modal).modal('hide');
    }, NEWS_FILTER_MODAL_CLOSE_MS);
  });

  modal.addEventListener('hidden.bs.modal', function() {
    modal.classList.remove('sheet-closing');
    modal.dataset.allowSheetHide = 'false';
  });
}

function ensureNewsFinishedMessage($list) {
  if ($list.find(`.${NEWS_FINISHED_MESSAGE_CLASS}`).length > 0) return;

  $list.append(
    `<p class="fs-small text-black-50 text-center mt-3 ${NEWS_FINISHED_MESSAGE_CLASS}">Alle Ergebnisse gesehen</p>`
  );
}

function ensureNewsFilterHint($list) {
  if (!isNewsFilterActive() || $list.find(`.${NEWS_FILTER_HINT_CLASS}`).length > 0) return;

  const filterElement = $('<p></p>')
    .addClass(`ps-2 c-pointer text-center text-decoration-underline fs-small text-primary fw-bold ${NEWS_FILTER_HINT_CLASS}`)
    .attr('data-bs-target', '#articles-filter-modal')
    .attr('data-bs-toggle', 'modal')
    .text('Filter aktiviert');

  $list.append(filterElement);
}

function initializeNewsImageSliders() {
  $('.article-image-slider.slider').not('.slick-initialized').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: false,
    nextArrow: false,
  });
}

function normaliseNewsListResponse(response) {
  if (Array.isArray(response)) {
    return { articles: response, pagination: null };
  }

  if (!response || typeof response !== 'object') {
    return { articles: null, pagination: null };
  }

  if (Array.isArray(response.data)) {
    return {
      articles: response.data,
      pagination: response.pagination || null
    };
  }

  if (response.data && typeof response.data === 'object') {
    return {
      articles: Array.isArray(response.data.data) ? response.data.data : null,
      pagination: response.data.pagination || response.pagination || null
    };
  }

  return {
    articles: null,
    pagination: response.pagination || null
  };
}

function extractPaginationNumber(pagination, keys) {
  if (!pagination || typeof pagination !== 'object') return null;

  for (let i = 0; i < keys.length; i += 1) {
    const rawValue = pagination[keys[i]];
    const numericValue = Number(rawValue);
    if (Number.isFinite(numericValue) && numericValue >= 0) {
      return numericValue;
    }
  }

  return null;
}

function updateNewsScrollStateFromPagination(state, pagination, fetchedCount) {
  const perPage = extractPaginationNumber(pagination, ['per_page', 'perPage']);
  const totalPages = extractPaginationNumber(pagination, ['total_pages', 'totalPages', 'pages']);
  const totalEntries = extractPaginationNumber(pagination, ['total_entries', 'totalEntries']);

  if (perPage && perPage > 0) {
    state.pageSize = perPage;
  }

  if (totalPages !== null) {
    state.totalPages = totalPages;
    state.hasMorePages = state.currentPage < totalPages;
    return;
  }

  if (totalEntries !== null) {
    state.totalEntries = totalEntries;
    state.hasMorePages = state.loadedEntries < totalEntries;
    return;
  }

  const fallbackPageSize = state.pageSize || fetchedCount;
  if (!fallbackPageSize || fetchedCount === 0) {
    state.hasMorePages = false;
    return;
  }

  state.pageSize = fallbackPageSize;
  state.hasMorePages = fetchedCount >= fallbackPageSize;
}

function buildNewsDebugTitle(article) {
  if (!(window.location.href.includes('localhost') ||
        window.location.href.includes('lvh.me') ||
        window.location.href.includes('meinort-test'))) {
    return '';
  }

  return escapeHtml(
    `<onlyDev>\n` +
    `"lw_id": "${article['lw_id'] || ''}"\n` +
    `"title": "${article['title'] || ''}"\n` +
    `"public_from_date": "${article['public_from_date'] || ''}"\n` +
    `"public_to_date": "${article['public_to_date'] || ''}"\n` +
    `"sort_pin_until": "${article['sort_pin_until'] || ''}"\n` +
    `"push_article": "${article['push_article'] || ''}"\n` +
    `</onlyDev>`
  );
}

function buildNewsPinBadgeHtml(article, pinLabel) {
  const pinUntil = article['sort_pin_until'];
  const badgeLabel = String(pinLabel || '').trim() || 'Im Fokus';
  const pinActive = pinUntil && new Date() < new Date(pinUntil);
  if (!pinActive) return '';

  return `<div class="fokusbadge badge d-flex align-items-center"><span class="fokusbadge__text">📍 ${escapeHtml(badgeLabel)}</span></div>`;
}

function formatNewsPublicationDate(publicationDate) {
  const parsedDate = moment(publicationDate);
  return parsedDate.isValid() ? parsedDate.format('DD.MM.YYYY') : '';
}

function hasVisibleNewsImages(article) {
  const images = Array.isArray(article['images_data']) ? article['images_data'] : [];
  const flagShowImages = article['flag_show_images_on_list'];
  const allowImages =
    flagShowImages === true ||
    flagShowImages === 'true' ||
    flagShowImages === null ||
    flagShowImages === undefined ||
    flagShowImages === '';

  return allowImages && images.length > 0;
}

function isBlankArticleBody(bodyHtml) {
  return String(bodyHtml || '').replace(/<[^>]*>/g, '').trim().length === 0;
}

function buildNewsImageDescription(image) {
  let imageDescription = String(image['caption'] || '').trim();
  if (image['photographer']) {
    imageDescription += `${imageDescription.length > 0 ? ' | ' : ''}Foto: ${image['photographer']}`;
  }
  return imageDescription;
}

function buildNewsArticleHref(article) {
  const ortId = getCurrentOrtId();
  return ortId ? `/neues/${article['lw_id']}?ort=${ortId}` : `/neues/${article['lw_id']}`;
}

function buildNewsArticleImageMarkup(article, href) {
  const images = Array.isArray(article['images_data']) ? article['images_data'] : [];
  if (!hasVisibleNewsImages(article)) return '';

  if (images.length === 1 && isBlankArticleBody(article['body_html'])) {
    const image = images[0];
    const imageDescription = buildNewsImageDescription(image);
    const lightboxId = escapeHtml(article['id'] || article['lw_id']);
    const imageAlt = imageDescription || `${article['title'] || 'Artikel'}-Bild`;

    return (
      '<div class="col-lg-4">' +
        '<div class="img-blur-wrap d-flex justify-content-center" style="height: 160px">' +
          `<div class="img-blur-bg c-pointer" style="height: 160px; background-image: url('${escapeHtml(image['thumb'] || image['orig'] || '')}');"></div>` +
          `<a href="${href}" data-turbo="false" data-lightbox="${lightboxId}" data-title="${escapeHtml(imageDescription)}">` +
            `<img src="${escapeHtml(image['orig'] || image['thumb'] || '')}" class="img-blur" style="height: 100%; width: 100%;" alt="${escapeHtml(imageAlt)}">` +
          '</a>' +
        '</div>' +
      '</div>'
    );
  }

  const slides = images.map((image) => (
    '<div class="img-blur-wrap">' +
      `<div class="img-blur-bg" style="height: 160px; background-image: url('${escapeHtml(image['thumb'] || image['orig'] || '')}');"></div>` +
      `<div class="img-blur" style="background-size: contain; height: 160px; background-image: url('${escapeHtml(image['orig'] || image['thumb'] || '')}');"></div>` +
    '</div>'
  )).join('');

  return `<a class="text-decoration-none col-lg-4 article-image-slider slider" href="${href}">${slides}</a>`;
}

function buildNewsArticleMarkup(article, options) {
  const href = buildNewsArticleHref(article);
  const hasImageColumn = hasVisibleNewsImages(article);
  const isSingleLightboxImage = hasImageColumn &&
    Array.isArray(article['images_data']) &&
    article['images_data'].length === 1 &&
    isBlankArticleBody(article['body_html']);
  const publishedDate = formatNewsPublicationDate(article['publication_date']);
  const showNewBadge = moment().diff(moment(article['publication_date']), 'hours') <= 24 &&
    !options.readArticleIds.has(String(article['lw_id']));
  const linkTurboAttribute = isSingleLightboxImage ? ' data-turbo="false"' : '';

  return (
    `<li class="pe-3 ps-3 pt-3" data-article-id="${escapeHtml(article['lw_id'])}"` +
      `${options.debugTitle ? ` title="${options.debugTitle}"` : ''}>` +
      '<div class="row mt-2">' +
        buildNewsArticleImageMarkup(article, href) +
        `<div class="${hasImageColumn ? 'col-lg-8' : 'col-12'}">` +
          `<a class="text-decoration-none link-dark" href="${href}"${linkTurboAttribute}>` +
            '<div class="row">' +
              '<div class="col-12 mb-2 mt-3 mt-lg-0 d-flex justify-content-between align-items-center">' +
                `<div class="text-thin common-text-black justify-content-between">${escapeHtml(publishedDate)} - ${escapeHtml(options.cityName)}</div>` +
                '<div class="d-flex align-items-center gap-2">' +
                  buildNewsPinBadgeHtml(article, options.pinLabel) +
                  (showNewBadge ? NEW_BADGE : '') +
                '</div>' +
              '</div>' +
              '<div class="col-12">' +
                `<h3 class="h5 fw-bold text-dark word-break-normal">${escapeHtml(article['title'] || '')}</h3>` +
              '</div>' +
              '<div class="col-12 d-lg-block d-none mt-2">' +
                `<p class="text-truncate text-truncate-3">${article['share_desc'] || ''}</p>` +
              '</div>' +
              '<div class="row">' +
                '<div class="col-10 d-flex align-items-center common-text-black">' +
                  '<div class="icon-paragraph-left-align fs-6"></div>' +
                  `<span class="mb-0 ps-2">${escapeHtml(article['subtitle'] || '')}</span>` +
                '</div>' +
                '<div class="col-2 d-flex justify-content-end pe-0">' +
                  '<div class="icon-navigation-menu-horizontal"></div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</a>' +
        '</div>' +
      '</div>' +
      '<hr class="border-2 border-top border-gray mt-3 mb-0">' +
    '</li>'
  );
}

function appendNewsArticles(state, articles) {
  const existingArticleIds = getRenderedNewsArticleIds();
  const readArticleIds = getNewsReadArticleIds();
  const pinLabel = state.$list.data('pin-label') || 'Im Fokus';
  const cityName = getCurrentCityName();
  const articleMarkup = [];

  articles.forEach((article, index) => {
    if (!article || typeof article !== 'object') {
      logNewsScroll('warn', 'Skipping malformed article payload', { index, article });
      return;
    }

    const articleId = String(article['lw_id'] || '');
    if (!articleId) {
      logNewsScroll('warn', 'Skipping article without lw_id', { index, article });
      return;
    }

    if (existingArticleIds.has(articleId)) {
      logNewsScroll('warn', `Skipping duplicate article "${articleId}"`);
      return;
    }

    articleMarkup.push(
      buildNewsArticleMarkup(article, {
        cityName,
        debugTitle: buildNewsDebugTitle(article),
        pinLabel,
        readArticleIds
      })
    );
    existingArticleIds.add(articleId);
  });

  if (articleMarkup.length > 0) {
    state.$list.append(articleMarkup.join(''));
  }

  return articleMarkup.length;
}

function stopNewsInfiniteScroll(state, reason = 'finished') {
  if (!state) return;

  state.hasMorePages = false;
  state.isLoading = false;

  if (state.scrollHandler && typeof state.scrollHandler.cancel === 'function') {
    state.scrollHandler.cancel();
  }

  $(window).off(`scroll${NEWS_SCROLL_NAMESPACE} resize${NEWS_SCROLL_NAMESPACE}`);
  removeNewsLoader();
  ensureNewsFinishedMessage(state.$list);
  ensureNewsFilterHint(state.$list);
  logNewsScroll('info', `Stopped infinite scroll (${reason})`, {
    currentPage: state.currentPage,
    loadedEntries: state.loadedEntries,
    totalPages: state.totalPages,
    totalEntries: state.totalEntries
  });
}

function destroyNewsInfiniteScroll() {
  if (!newsInfiniteScrollState) return;

  const state = newsInfiniteScrollState;
  state.hasMorePages = false;
  state.isLoading = false;

  if (state.scrollHandler && typeof state.scrollHandler.cancel === 'function') {
    state.scrollHandler.cancel();
  }

  $(window).off(`scroll${NEWS_SCROLL_NAMESPACE} resize${NEWS_SCROLL_NAMESPACE}`);
  removeNewsLoader();
  logNewsScroll('debug', 'Cleaned up infinite scroll listeners');
  newsInfiniteScrollState = null;
}

async function loadNextNewsPage(state) {
  if (!state || state.isLoading || !state.hasMorePages) return;

  const nextPage = state.currentPage + 1;
  state.isLoading = true;
  showNewsLoader(state.$list);
  logNewsScroll('debug', `Loading page ${nextPage}`);

  try {
    const response = await getNewsList(nextPage);
    const normalisedResponse = normaliseNewsListResponse(response);

    if (!Array.isArray(normalisedResponse.articles)) {
      throw new Error('Unexpected news response format');
    }

    const fetchedArticles = normalisedResponse.articles;
    const renderedCount = appendNewsArticles(state, fetchedArticles);

    state.currentPage = nextPage;
    state.loadedEntries += renderedCount;
    updateNewsScrollStateFromPagination(state, normalisedResponse.pagination, fetchedArticles.length);

    logNewsScroll('debug', `Loaded page ${nextPage}`, {
      fetchedCount: fetchedArticles.length,
      renderedCount,
      hasMorePages: state.hasMorePages,
      pagination: normalisedResponse.pagination
    });

    if (fetchedArticles.length === 0 || renderedCount === 0 || !state.hasMorePages) {
      stopNewsInfiniteScroll(state, fetchedArticles.length === 0 ? 'empty-response' : 'last-page');
    } else {
      initializeNewsImageSliders();
      if (isNearNewsPageBottom()) {
        state.scrollHandler();
      }
    }
  } catch (error) {
    logNewsScroll('error', `Failed to load page ${nextPage}`, error);
  } finally {
    state.isLoading = false;
    removeNewsLoader();
  }
}

function initializeNewsInfiniteScroll() {
  destroyNewsInfiniteScroll();

  if (!isNewsIndexPage()) return;

  const $list = $('#news-loaded-list');
  const state = {
    $list,
    currentPage: 1,
    isLoading: false,
    hasMorePages: true,
    pageSize: Number($list.data('page-size')) || null,
    totalPages: null,
    totalEntries: null,
    loadedEntries: $('[data-article-id]').length,
    scrollHandler: null
  };

  state.scrollHandler = debounce(() => {
    if (!state.hasMorePages || state.isLoading) return;
    if (!isNearNewsPageBottom()) return;
    loadNextNewsPage(state);
  }, NEWS_SCROLL_DEBOUNCE_MS);

  newsInfiniteScrollState = state;
  $(window).on(`scroll${NEWS_SCROLL_NAMESPACE} resize${NEWS_SCROLL_NAMESPACE}`, state.scrollHandler);
  logNewsScroll('info', 'Initialized infinite scroll', {
    currentPage: state.currentPage,
    loadedEntries: state.loadedEntries,
    pageSize: state.pageSize
  });

  state.scrollHandler();
}

// $(document).on('turbo:load', function () {
$(document).ready(function () {
  /* --- <WORKAROUND> ---
   * I was unable to register a callback for the hook 'bs.show.modal' when
   * opening the filter-modal, so I had to register a click-listener when the
   * user triggers the modal-open-action [MS, 240421] */
  $(document).on('click', '#btnFN', function(){
    let rubrics   = [];
    let date_from = null;
    let date_to   = null;
    let online_categories = [];
    let storr = getNewsFiltersFromStorage();

    if (storr) {
      rubrics   = normaliseFilterValues(storr.rubric_level_two_names);
      date_from = storr.date_from;
      date_to   = storr.date_to;
      online_categories = normaliseFilterValues(storr.mo_onlinecategories, '|');
    } else {
      // collect all inital values of [data-rubric]
      rubrics = $('[data-rubric]').map(function() { return $(this).data('rubric'); }).get();
    }

    if (rubrics.length == 0) {
      rubrics = $('[data-rubric]').map(function() { return $(this).data('rubric'); }).get();
      // ["App-Brey", "App-VG-Rhein-Mosel"]
    }
    console.log('rubrics -> ' + rubrics);

    // update the view
    $('#newsFilterList li').each(function(){
      console.log("$('#newsFilterList li')");
      let bChecked = $(this).find('.icon-checkbox-checked').length == 1;
      let rubric = $(this).data('rubric'); // 'App-Brey'
      if ( rubrics.indexOf(rubric) > -1 ) {
        if (!bChecked) {
          toggleCheckbox( $(this).find('i') );
        }
      } else {
        if (bChecked) {
          toggleCheckbox( $(this).find('i') );
        }
      }
    });

    // update the category view
    $('#newsCategoryFilterList li').each(function(){
      let bChecked = $(this).find('.icon-checkbox-checked').length == 1;
      let online_category = $(this).data('onlinecategory');
      if (online_categories.indexOf(online_category) > -1) {
        if (!bChecked) {
          toggleCheckbox($(this).find('i'));
        }
      } else if (bChecked) {
        toggleCheckbox($(this).find('i'));
      }
    });

    $('input#mo_onlinecategories').val(online_categories.join('|'));

    if (date_from && date_to) {
      let date_from_ger = convEnDateToGer(date_from);
      let date_to_ger   = convEnDateToGer(date_to);
      $('input#date_range_articles').val(date_from_ger + " - " + date_to_ger);
      $("#date_range_articles").data('daterangepicker').setStartDate(date_from_ger);
      $("#date_range_articles").data('daterangepicker').setEndDate(date_to_ger);
    } else {
      $('input#date_range_articles').val('');
      $('input#date_range_articles').attr("placeholder", "Auswählen").blur();
    }
  });

  /*
   * User wants to perform filtering on news.
   * a) put filter-values in localstorage,
   * b) fill hidden-fields,
   * c) ...and perform request
   */
  $(document).on('submit', 'form#neues-filter-form', function(){
    console.log("submit $(document).on('submit', 'form#neues-filter-form'");
    console.log("$(document).on('submit', 'form#neues-filter-form', function(){");
    // a) put filter-values in localstorage
    const rubrics = $('[data-rubric]').map(function() {
      if ($(this).find('.icon-checkbox-checked').length > 0 ) {
        return $(this).data('rubric');
      }
      return null;
    }).get(); // --> ["App-VG-Rhein-Mosel"]
    const online_categories = $('[data-onlinecategory]').map(function() {
      if ($(this).find('.icon-checkbox-checked').length > 0 ) {
        return $(this).data('onlinecategory');
      }
      return null;
    }).get();

    const date_from = $('input#date_from').val();
    const date_to   = $('input#date_to').val();
    const nf = {
      rubric_level_two_names: rubrics,
      mo_onlinecategories: online_categories,
      date_from: date_from,
      date_to: date_to,
      filter_ort: window.localStorage.getItem('current_city_id')
    };
    window.localStorage.setItem('news_filters', JSON.stringify(nf));

    // b) fill hidden-fields...
    $('input#rubric_level_two_names').val(rubrics.join(','))
    $('input#mo_onlinecategories').val(online_categories.join('|'))
    $('input#date_from').val(date_from);
    $('input#date_to').val(date_to);

    // c) ...and perform request
  });
  // Opening lightbox for article show with no body
  var container = $('.row.justify-content-center[data-emptybody="1"]');
  container.find('a[data-lightbox]').first().click();
});

function toggleCheckbox(i) {
  if (i.hasClass("icon-checkbox-checked")) {
    i.removeClass("icon-checkbox-checked").addClass("icon-checkbox-none")
  } else {
    i.removeClass("icon-checkbox-none").addClass("icon-checkbox-checked");
  }
}

function syncFilterButtonFromStorage() {
  if ($('#btnFN').length === 0) return;

  const isActive = isNewsFilterActive();
  const $icon = $('#btnFN').closest('.align-items-baseline').find('.icon-filter-1');

  if (isActive) {
    $icon.addClass('text-primary fw-bold');
    $('#btnFN').addClass('text-primary fw-bold');
    if ($('#btnFN').siblings('.icon-check').length === 0) {
      $('#btnFN').after('<div class="icon-check ps-1 text-primary fw-bold"></div>');
    }
  } else {
    $icon.removeClass('text-primary fw-bold');
    $('#btnFN').removeClass('text-primary fw-bold');
    $('#btnFN').siblings('.icon-check').remove();
  }
}

$(document).on('turbo:load', function (e) {
  console.log(`neues.js - turbo:load e.originalEvent.detail.url=${e.originalEvent.detail.url}`);
  // no matter if being on the article#index or #show: make sure that articles
  // that had been read by the user, do not show up with a NEU-badge
  removeArticlesNeuBadges(false);
  removeEventsNeuBadges(false);
  initializeNewsFilterModalAnimation();
  initializeNewsInfiniteScroll();

  syncFilterButtonFromStorage();

  // handle article-reading (after ARTICLE_READ_HOOK_DELAY)
  window.setTimeout(function(){
    handleArticleReading(e);
    handleEventReading(e);
  }, ARTICLE_READ_HOOK_DELAY);

  $("#newsFilterList li").on("click", function() {
    //console.log('$("#newsFilterList li").on("click", function() {');
    if ($('#newsFilterList li').length < 2 || $('#newsFilterList .icon-checkbox-checked').length === 1 && $(this).find('i').hasClass('icon-checkbox-checked')) return;
    toggleCheckbox($(this).find('i'));
    // window.localStorage.setItem('news_filters', JSON.stringify(news_filters));
  });

  $("#newsCategoryFilterList li").on("click", function() {
    toggleCheckbox($(this).find('i'));
  });

  $("#reset-news-category-filter").on("click", function() {
    $("#newsCategoryFilterList li").each(function() {
      if ($(this).find('.icon-checkbox-checked').length > 0) {
        toggleCheckbox($(this).find('i'));
      }
    });
  });

  if ($("#date_range_articles").length > 0) {
    if (typeof $.fn.daterangepicker === 'function') {
      $("#date_range_articles").daterangepicker({
        opens: 'left',
        drops: 'up',
        minDate: moment().subtract(1, 'months').toDate(),
        maxDate: moment().startOf('day'), // Set the minimum date to today
        locale: {
          format: "DD.MM.YYYY",
          separator: " - ",
          applyLabel: "Speichern",
          cancelLabel: "Löschen",
          fromLabel: "From",
          toLabel: "To",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          monthNames: ["Januar", "Februar", "M&auml;rz", "April", "Mai", "Juni", "Juli",
                       "August", "September", "Oktober", "November", "Dezember"],
          firstDay: 1
        },
        applyButtonClasses: "btn-secondary text-white"
        // TOD: activate:
        // ,
        // startDate: news_filters && moment(news_filters.date_from).format('DD-MM-YYYY'),
        // endDate: news_filters && moment(news_filters.date_to).format('DD-MM-YYYY')
      }, function(start, end, label) {
        console.log('}, function(start, end, label) {');
        let filters_ = getNewsFiltersFromStorage();
        // Get the start and end times in ISO format
        const date_from = moment(start).format('YYYY-MM-DD');
        const date_to = moment(end).format('YYYY-MM-DD');

        // Set the values of the hidden fields
        $('#date_from').val(date_from);
        $('#date_to').val(date_to);
        // Store the start and end times in localStorage
        let news_filters = {
          rubric_level_two_names: normaliseFilterValues(filters_.rubric_level_two_names),
          mo_onlinecategories: normaliseFilterValues(filters_.mo_onlinecategories, '|'),
          date_from: date_from,
          date_to: date_to,
          filter_ort: window.localStorage.getItem('current_city_id')
        };
        window.localStorage.setItem('news_filters', JSON.stringify(news_filters));
      });

      // Disable future dates in the datepicker
      $('#date_range_articles').on('show.daterangepicker', function(ev, picker) {
        console.log("$('#date_range_articles').on('show.daterangepicker'");
        const maxDate = moment().endOf('day'); // Set the maximum date to today
        picker.maxDate = maxDate;
        picker.setEndDate(maxDate);
      });


      // Disable future dates in the datepicker
      $('#date_range_articles').on('cancel.daterangepicker', function(ev, picker) {
        console.log("$('#date_range_articles').on('cancel.daterangepicker'");
        $('#date_from').val('');
        $('#date_to').val('');
        $('input#date_range_articles').val('');
        $('input#date_range_articles').attr("placeholder", "Auswählen").blur();
        // let filters_ = JSON.parse(window.localStorage.getItem('news_filters'));
        // let news_filters = { rubric_level_two_names: filters_ ? filters_.rubric_level_two_names : [], date_from: date_from, date_to: date_to }
        // window.localStorage.setItem('news_filters', JSON.stringify(news_filters));
      });
    } else {
      console.error('daterangepicker is unavailable on #date_range_articles');
    }
  }
});

$(document).on('turbo:before-cache', function () {
  destroyNewsInfiniteScroll();
});

async function getNewsList(page_count) {
  const requestParams = new URLSearchParams({
    page: page_count,
    rubric_level_two_names: getNewsFilterRequestValue('rubric-level-two-names'),
    mo_onlinecategories: getNewsFilterRequestValue('mo-onlinecategories'),
    date_from: getNewsFilterRequestValue('date-from'),
    date_to: getNewsFilterRequestValue('date-to')
  });
  const requestUrl = `/load-new-neues?${requestParams.toString()}`;

  logNewsScroll('debug', `Requesting ${requestUrl}`);
  const response = await fetch(requestUrl, {
    method: 'get',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} while loading ${requestUrl}`);
  }

  return response.json();
}

var getUrlParameter = function getUrlParameter(sParam) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(sParam) || "";
};
